<template>
    <section id="section">
        <div class="tab-lists-container">
            <div class="tab-title-container">
                <div class="tab-m-title-container">
                    <i class="icon-studio"></i>
                    <span class="tab-m-title">工作室</span>
                </div>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>

        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in studios" :key="v.id">
                <div class="dancer-lists-link">
                    <router-link class="dancer-thumb-link pr" :to="`/studios/${v.id}`"><img class="dancer-thumb" v-lazy="{src: v.thumb, error: 'https://img.vhiphop.com/web/loading-1.gif', loading: 'https://img.vhiphop.com/web/loading-1.gif'}" :alt="v.name"></router-link>

                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <router-link :to="`/studios/${v.id}`" class="dancer-title-link">
                                <h3 class="video-title ellipsis">{{v.name}}</h3>
                            </router-link>

                            <span class="dancer-tips ellipsis">{{v.country}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="dancer-counts" :title="`人气值: ${v.views}`">
                                <i class="icon-hot"></i> {{v.views > 9999 ? `${Math.round(v.views  / 1000) / 10}万` : v.views}}
                            </span>
                            <span class="dancer-counts" :title="`关注: ${v.fans}`">
                                <i class="icon-liked"></i> {{v.fans}}
                            </span>
                        </p>
                    </div>
                </div>
            </li>
        </ul>

    </section>
</template>

<script>
    export default {
        data: () => ({
            studios: [],
        }),
        beforeMount() {
            this.api.get('studios').then(e => {
                this.studios = e;
            }, this.err);
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/dancer/lists.css";
    @import "../../../static/css/common/tab.css";
</style>



// WEBPACK FOOTER //
// src/views/studio/List.vue